import moment from 'moment';

import { stripTrackingDetailMessage } from 'utils/strings';

import Base from 'app/models/base';

export default Base.extend({
  parse(attrs) {
    return {
      ...attrs,
      datetime: moment(attrs.datetime || '').utc(),
      message: stripTrackingDetailMessage(attrs.message, attrs.carrier),
    };
  },
});



// WEBPACK FOOTER //
// ./app/models/tracking_detail.js